var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"md"}),_c('div',{staticClass:"lg"},[_c('a',{staticClass:"PCa",attrs:{"href":'https://sem.rlcpluspro.com/subject/download?channel='+_vm.v}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }